import type { CSSProperties } from 'react';

export const FIXED_LIST_VIEW_COLUMN_IDS = new Set(['select', 'type', 'thumbnail', 'actions']);

export function getListViewFillColumnId(columnIds: string[]): string | undefined {
  return columnIds.findLast((columnId) => !FIXED_LIST_VIEW_COLUMN_IDS.has(columnId));
}

export function getListViewColumnStyle(columnId: string, columnSize: number, fillColumnId?: string): CSSProperties {
  if (FIXED_LIST_VIEW_COLUMN_IDS.has(columnId)) {
    return {
      width: columnSize,
      minWidth: columnSize,
      maxWidth: columnSize,
    };
  }

  if (columnId === fillColumnId) {
    return {
      width: 'auto',
      minWidth: columnSize,
    };
  }

  return {
    width: columnSize,
    minWidth: columnSize,
    maxWidth: columnSize,
  };
}

/** Compute a className string for a cell based on its column id and optional column meta. */
export function getCellClassName(
  columnId: string,
  classes: Record<string, string>,
  meta?: { isNameColumn?: boolean },
): string {
  const base = classes.bodyCell ?? '';
  switch (columnId) {
    case 'select':
      return [base, classes.selectCell].filter(Boolean).join(' ');
    case 'type':
      return [base, classes.typeCell].filter(Boolean).join(' ');
    case 'thumbnail':
      return [base, classes.thumbnailCell].filter(Boolean).join(' ');
    case 'actions':
      return [base, classes.actionsCell].filter(Boolean).join(' ');
    default:
      if (meta?.isNameColumn) {
        return [base, classes.nameCell].filter(Boolean).join(' ');
      }
      return base;
  }
}
